(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("echarts"), require("ccxd-ux"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["echarts", "ccxd-ux", ], factory);
	else if(typeof exports === 'object')
		exports["common-ui"] = factory(require("echarts"), require("ccxd-ux"), require("vue"));
	else
		root["common-ui"] = factory(root["echarts"], root["ccxd-ux"], root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__164e__, __WEBPACK_EXTERNAL_MODULE__3dc9__, __WEBPACK_EXTERNAL_MODULE__8bbf__) {
return 